import axios from 'axios';
import PathManagement, { XhrQueryParam } from '../path-management';
import { getAction, XhrStatusResponse, operationSuccess, postAction, getResponseByUrl } from '../xhr';
import { IUsuarioRol } from './usuario-rol';
import statusResponse from '../status-response';

const entityName = 'Usuario';
const validateEmailAction = 'isAvailable';
const validateEmailForUserInfoAction = 'isAvailableForUserInfo';
const validateEmailForRecoveryPasswordAction = 'isAvailableForRecoveryPassword';
const isLoggedInAction = 'isLoggedIn';
const VinculateRRSSAction = 'VincularRRSS';
const ActivateUserAction = 'activateUser';
const searchForUsersByCuit = 'getUsersByCuit';
const checkCuitAvailability = 'isCuitAvailable';

export interface IRegistro {
  RegisterData: any;
  rsId: string;
  rsUserId: string;
  token: string;
}

export interface IVinculation {
  rsId: string;
  rsUserId: string;
  rsEmail: string;
}

export interface IUsuario {
  us_accweb: boolean;
  us_cliid?: string;
  us_decid_habitual?: string;
  us_email: string;
  us_estado: string;
  us_id: string;
  us_login: string;
  us_nivel: string;
  us_nombre: string;
  us_origen_vinculo: string;
  us_password: string;
  us_pregunta: string;
  us_respuesta: string;
  us_rs_userid: string;
  us_rsid?: string;
  us_supervisor_id?: string;
  us_ur_id: '00000007';
  us_limite_compra: number;
}

export interface IUsuarioExtended extends IUsuario {
  usuarioRol: IUsuarioRol;
}

export const validateEmail = async (email: string): Promise<boolean> => {
  const query: XhrQueryParam[] = [
    { name: 'email', value: email },
    { name: 'dispatcher', value: validateEmailAction },
  ];
  const res = await getAction<XhrStatusResponse>(entityName, query);

  return operationSuccess(res);
};

export const validateEmailForUserInfo = async (email: string, id: string): Promise<boolean> => {
  const query: XhrQueryParam[] = [
    { name: 'email', value: email },
    { name: 'id', value: id },
    { name: 'dispatcher', value: validateEmailForUserInfoAction },
  ];
  const res = await getAction<XhrStatusResponse>(entityName, query);

  return operationSuccess(res);
};

export const validateEmailForRecoveryPassword = async (email: string): Promise<boolean> => {
  const query: XhrQueryParam[] = [
    { name: 'email', value: email },
    { name: 'dispatcher', value: validateEmailForRecoveryPasswordAction },
  ];
  const res = await getAction<XhrStatusResponse>(entityName, query);

  return operationSuccess(res);
};

//chequear esto porque cambio como le llegan los datos
export const registro = async (d: IRegistro): Promise<statusResponse> => {
  const res = await postAction<IRegistro>(entityName, d);
  return res;
};

export const isLoggedIn = async () => {
  const res = await getAction<XhrStatusResponse<IUsuarioExtended>>(isLoggedInAction);

  // if (!operationSuccess(res)) throw new Error('Hubo un error');

  return res.data;
};

export const VinculateRRSS = async (rsId: string, rsUserId: string, rsEmail: string) => {
  const query: XhrQueryParam[] = [
    { name: 'email', value: rsEmail },
    { name: 'dispatcher', value: VinculateRRSSAction },
  ];
  const res = await getAction<XhrStatusResponse>(entityName, query);

  return operationSuccess(res);
};

export const ActivateUser = async (email: string, otp_activacion: string, tokenCaptcha: any) => {
  // let data = { email: email, token: token, tokenCaptcha: tokenCaptcha }
  let data = { email: email, otp_activacion: otp_activacion };

  const query: XhrQueryParam[] = [{ name: 'dispatcher', value: ActivateUserAction }];
  const res = await postAction(entityName, data, query);

  return operationSuccess(res);
};

export const logoutUser = async (): Promise<LoginData> => {
  let _pathManager = new PathManagement();
  let url = _pathManager.getLogoutUrl();
  let response = null;
  try {
    response = await getResponseByUrl(url);
  } catch (err) {
    console.error(err, 'error al intentar hacer logout');
  }
  return response;
};

export interface LoginData {
  loginData: string;
}

export const getUsersByCuit = async (cuit: string) => {
  const query: XhrQueryParam[] = [
      { name: 'cuit', value: cuit },
      { name: 'dispatcher', value: searchForUsersByCuit },
    ];
    const res = await getAction<XhrStatusResponse>(entityName, query);

    return res;
}

export const isCuitAvailable = async (cuit: string) => {
  const query: XhrQueryParam[] = [
      { name: 'cuit', value: cuit },
      { name: 'dispatcher', value: checkCuitAvailability },
    ];
    const res = await getAction<XhrStatusResponse>(entityName, query);

    if (res.data) {
      return res.data;
    } else {
      return false;
    }

}
